module.exports = __webpack_public_path__ + "img/02_DSC7510-min.3b87ff83.jpg";